import { render, staticRenderFns } from "./MileagePrices.vue?vue&type=template&id=67a72440&scoped=true"
import script from "./MileagePrices.vue?vue&type=script&lang=js"
export * from "./MileagePrices.vue?vue&type=script&lang=js"
import style0 from "./MileagePrices.vue?vue&type=style&index=0&id=67a72440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a72440",
  null
  
)

export default component.exports